import _ from 'lodash'
import store from '@/store'
import * as constants from '@/store/constants'
import * as types from '@/store/types'
import SimpleVueValidator from 'simple-vue-validator';
const Validator = SimpleVueValidator.Validator;

const airMixin = {
    validators: {
       
    }
}

export default airMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/Air-validators.js